import { Component } from '@angular/core';
import { Router, NavigationEnd, ActivationEnd } from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import { SwJwtService } from './librarys/serves/sw-jwt.service';
import { environment } from 'src/environments/environment';
// import { OninitService } from './librarys/serves/oninit.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  constructor(private router : Router,
    public translateService: TranslateService,
    private jwt: SwJwtService){
  }

  async ngOnInit(): Promise<void> {
    let defaultLang = environment.defaultLanguage;
    if(!defaultLang){
      defaultLang = 'zh-CN';
    }
      /* --- set i18n begin ---*/
      this.translateService.addLangs(['zh-CN', 'en-US']);
      this.translateService.setDefaultLang(defaultLang);
      let currentLanguage = await this.jwt.getToken("language") || defaultLang;
      this.translateService.use(currentLanguage);
      this.jwt.setToKen("language",currentLanguage);
      /* --- set i18n end ---*/
      this.getBrowserInfo();  //判断浏览器内核  
    
  }

  
  getBrowserInfo(){
    //判断浏览器内核
    var ua = navigator.userAgent.toLocaleLowerCase();
    var browserType = null;
    if(ua.match(/msie/) != null || ua.match(/trident/) != null){
      browserType = "IE";
    } else if(ua.match(/firefox/) != null){
      browserType = "火狐";
    } else if(ua.match(/ubrowser/) != null){
      browserType = "UC";
    } else if(ua.match(/opera/) != null){
      browserType = "欧朋";
    } else if(ua.match(/bidubrowser/) != null){
      browserType = "百度";
    } else if(ua.match(/metasr/) != null){
      browserType = "搜狗";
    } else if(ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null){
      browserType = "QQ";
    } else if(ua.match(/maxthon/) != null){
      browserType = "遨游";
    } else if(ua.match(/chrome/) != null){
      var is360 = this.mime("type","application/vnd.chromium.remoting-viewer");
      if(is360){
        browserType = "360";
      } else {
        browserType = "谷歌";
      }
    } else if(ua.match(/safari/) != null){
      browserType = "safari";
    }
    if(browserType != "360" && browserType != "谷歌" && browserType != "safari"){
      // console.log('请使用推荐浏览器');
      //如果不是以上3种浏览器就跳转到提示页面
      this.router.navigate(['/compatibility'])
    }
  }
  mime(option,value){
    var mimeTypes = navigator.mimeTypes;
    for (const mt in mimeTypes) {
      if (mimeTypes[mt][option] === value) {
        return true;
        
      }
    }
    return false;
  }

  /* 每次路由进行跳转时,就将进度条设置在最上面 */
  ngAfterViewInit(): void {
    this.router.events.subscribe(function(event:NavigationEnd){
      if(event instanceof ActivationEnd){
        if(document.documentElement.getElementsByTagName('sw-main') && document.documentElement.getElementsByTagName('sw-main')[0] && document.documentElement.getElementsByTagName('sw-main')[0].children){
          let contentWrapper = document.documentElement.getElementsByTagName('sw-main')[0].children[0]
          let myWrapCont = contentWrapper.children[1]
          if(myWrapCont){
            myWrapCont.scrollTop = 0
          }

        }
      }
    })
  }
}
